import Vue from 'vue'

Vue.filter('toFixed', function (value, length = 2) {
  if (!value) return ''

  return value.toFixed(length)
})

Vue.filter('number', function (value, fractionDigits) {
  return (value || 0).toLocaleString('de-DE', {
    minimumFractionDigits: fractionDigits ? fractionDigits : undefined,
    maximumFractionDigits: fractionDigits ? fractionDigits : undefined
  })
})

Vue.filter('numberWithSign', function (value, fractionDigits) {
  const filter = Vue.filter('number')
  const string = filter(Math.abs(value), fractionDigits) // always positive number
  const sign = value === 0 ? '' : value > 0 ? '+' : '-'

  return `${sign} ${string}`
})
